import "./RemoveDeletedNotes.scss";
import { useTranslation } from "react-i18next";

function RemoveDeletedNotes({ cancelRemoveDeletedNotes, removeDeletedNotes }) {
  const { t } = useTranslation();
  return (
    <div className="remove-deleted-notes-content">
      <div className="modal-title">
        <div>{t("notes.modals.removeDeleted.title")}</div>
      </div>
      <div className="modal-body">
        <p>{t("notes.modals.removeDeleted.message")}</p>
        <p>
          <strong>{t("notes.modals.removeDeleted.cannotUndo")}</strong>
        </p>
      </div>
      <div className="modal-form-buttons">
        <button
          className="modal-button cancel"
          onClick={cancelRemoveDeletedNotes}
        >
          {t("common.cancel")}
        </button>
        <button className="modal-button delete" onClick={removeDeletedNotes}>
          {t("common.delete")}
        </button>
      </div>
    </div>
  );
}

export default RemoveDeletedNotes;
